module.exports = __webpack_public_path__ + "24e49fd1636880e32383f5df7fe36603.png";